export interface TPillPmcPromo {
  oldPrice: number
  newPrice: number
  discountPct: number
}

const parseMoneyValue = (value: unknown): number => {
  if (value == null) return NaN
  if (typeof value === 'number') return value
  // Aceita "49.03" (formato confirmado via GET /product/:id em dev) e "49,03" (defensivo).
  return Number(String(value).trim().replace(',', '.'))
}

/**
 * Extrai o valor cru de abcfarma_pmc_18, tolerante aos dois shapes reais:
 * - Listagens (/list-products, get-all-main): campo já achatado em `product.abcfarma_pmc_18`.
 * - GET /product/:id: só devolve o array cru de metafields em `product.shopifyMetafields`, cada
 *   item `{namespace, field, value}` — o registro real tem `namespace: 'custom'` (não 'abcfarma')
 *   e `field: 'abcfarma_pmc_18'` (confirmado via curl em dev, produto 26889).
 */
const findAbcfarmaPmc18Raw = (product: any): unknown => {
  if (product?.abcfarma_pmc_18 !== undefined) return product.abcfarma_pmc_18

  const metafields = product?.shopifyMetafields
  if (Array.isArray(metafields)) {
    return metafields.find((m: any) => m?.field === 'abcfarma_pmc_18')?.value
  }

  // Fallback defensivo (shape objeto direto, não confirmado em produção).
  return metafields?.abcfarma_pmc_18
}

/**
 * Preço "de tabela" (PMC/ABCFARMA) de produtos Pill. Só considera promoção válida quando o campo
 * existe, é numérico e é MAIOR que o preço atual — dado sujo (pmc ausente/<=0/<=price) não deve
 * gerar riscado nem percentual enganoso.
 */
export function getPillPmcPromo(product: any): TPillPmcPromo | null {
  if (product?.origin !== 'pill') return null

  const pmc = parseMoneyValue(findAbcfarmaPmc18Raw(product))
  const currentPrice = Number(product?.real_price ?? product?.price)

  if (!Number.isFinite(pmc) || pmc <= 0) return null
  if (!Number.isFinite(currentPrice) || currentPrice <= 0) return null
  if (pmc <= currentPrice) return null

  const discountPct = Math.round(((pmc - currentPrice) / pmc) * 100)
  if (discountPct <= 0) return null

  return { oldPrice: pmc, newPrice: currentPrice, discountPct }
}
